<template>
  <h2>
    <slot />
  </h2>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
h2 {
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 40px;
  font-family: var(--font-family-serif);
  font-weight: 600;
  line-height: 48px;
  text-align: left !important; /* NOTE @chris Global leak. */
}

@media (max-width: 960px) {
  h2 {
    font-size: 32px;
    line-height: 40px;
  }
}
</style>
